/** biome-ignore-all lint/correctness/useHookAtTopLevel: none */
/** biome-ignore-all lint/suspicious/noExplicitAny: none */
/** biome-ignore-all lint/suspicious/noArrayIndexKey: none */
/** biome-ignore-all lint/nursery/useSortedClasses: none */
import { CustomersIcon } from "@moznsystems/mozn-ui";
import { NavLink, useLocation } from "react-router-dom";

type SideBarProps = {
	setDrawerVisible: (status: boolean) => void;
};

export const SideBar = ({ setDrawerVisible }: SideBarProps) => {
	const location = useLocation();
	const active = location?.pathname?.split("/").join(",/").split(",");

	return (
		<ul className="side-bar__nav__group dashboard_menu">
			<li
				className={
					"side-bar__nav__item" +
					(active.indexOf("/tenants") !== -1
						? " side-bar__nav__item--active"
						: "")
				}
			>
				<div className="side-bar__nav__item--header">
					<NavLink
						onClick={() => {
							setDrawerVisible(false);
						}}
						className="side-bar__nav__item--main"
						to={"/tenants"}
					>
						<div>
							<CustomersIcon className="side-bar__nav__item__icon" />
							<span>Tenants</span>
						</div>
					</NavLink>
				</div>
			</li>
		</ul>
	);
};
